module.exports = __webpack_public_path__ + "img/ankith_pic.6d5fb6ee.png";